export default __webpack_public_path__ + "static/media/DEheader.55dbde02.png";